import CustomCard from "./reusable/CustomCard";

import suggestionClasses from "./SuggestionCard.module.css";
import cardClasses from "./reusable/CardDescription.module.css";

import { MasonCollinsSupplementRow } from "../pages/MetricPage/masonCollinsSupplementData";

interface Props {
  data: MasonCollinsSupplementRow;
}

const ROW_COLOR = "var(--secondary10)";
const BULLET_COLOR = "var(--primary1000)";
const COLUMN_WIDTH = "222px";

const TITLE_STYLE = {
  fontFamily: "AktivGroteskEx_A_Md",
  fontSize: "12px",
  lineHeight: "16px",
};

const MasonCollinsSuggestionCard = ({ data }: Props): JSX.Element => {
  return (
    <CustomCard cardPadding="10px 14px">
      <div className={suggestionClasses.title}>
        <div
          className={suggestionClasses.icon}
          style={{ backgroundColor: ROW_COLOR }}
        ></div>
        <div>{data.TITLE.toUpperCase()}</div>
      </div>

      <div className={suggestionClasses.description}>
        <ul className={suggestionClasses.columns}>
          {data.IMPROVE_AREAS.map((item) => (
            <li key={item.INDEX} className={suggestionClasses.sub}>
              <div
                className={cardClasses.sub}
                style={{ width: COLUMN_WIDTH, margin: 0 }}
              >
                <div className={cardClasses.inner}>
                  <div className={cardClasses.title} style={TITLE_STYLE}>
                    {item.TITLE}
                  </div>
                </div>
                <div className={cardClasses.subText}>May help the body:</div>
                <div>
                  {item.BULLETS.map((bullet, idx) => (
                    <div key={idx} className={cardClasses.listItem}>
                      <div
                        className={cardClasses.point}
                        style={{ backgroundColor: BULLET_COLOR }}
                      ></div>
                      <div
                        className={cardClasses.subText}
                        style={{ marginBottom: 0, flex: 1 }}
                      >
                        {bullet}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </CustomCard>
  );
};

export default MasonCollinsSuggestionCard;
